// extracted by mini-css-extract-plugin
module.exports = {"orange-shadow":"FeaturesTable_orange-shadow__17ocN","gradient":"FeaturesTable_gradient__3WfQ2","table-width":"FeaturesTable_table-width__2G6kt"};